/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Event_Group_Options_Merge_By_Speakers_FailedInputs */

const en_event_group_options_merge_by_speakers_failed = /** @type {(inputs: Event_Group_Options_Merge_By_Speakers_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to merge events: ${i?.error}`)
};

const fr_event_group_options_merge_by_speakers_failed = /** @type {(inputs: Event_Group_Options_Merge_By_Speakers_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec de la fusion des événements : ${i?.error}`)
};

const de_event_group_options_merge_by_speakers_failed = /** @type {(inputs: Event_Group_Options_Merge_By_Speakers_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zusammenführen der Ereignisse fehlgeschlagen: ${i?.error}`)
};

const it_event_group_options_merge_by_speakers_failed = /** @type {(inputs: Event_Group_Options_Merge_By_Speakers_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile unire gli eventi: ${i?.error}`)
};

const ru_event_group_options_merge_by_speakers_failed = /** @type {(inputs: Event_Group_Options_Merge_By_Speakers_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось объединить события: ${i?.error}`)
};

const es_event_group_options_merge_by_speakers_failed = /** @type {(inputs: Event_Group_Options_Merge_By_Speakers_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al fusionar eventos: ${i?.error}`)
};

const zh_cn2_event_group_options_merge_by_speakers_failed = /** @type {(inputs: Event_Group_Options_Merge_By_Speakers_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`事件合并失败：${i?.error}`)
};

const ja_event_group_options_merge_by_speakers_failed = /** @type {(inputs: Event_Group_Options_Merge_By_Speakers_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`イベントのマージに失敗しました: ${i?.error}`)
};

const hi_event_group_options_merge_by_speakers_failed = /** @type {(inputs: Event_Group_Options_Merge_By_Speakers_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`इवेंट्स को मर्ज करने में विफल: ${i?.error}`)
};

const pt_pt2_event_group_options_merge_by_speakers_failed = /** @type {(inputs: Event_Group_Options_Merge_By_Speakers_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao mesclar eventos: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to merge events: {error}" |
*
* @param {Event_Group_Options_Merge_By_Speakers_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_merge_by_speakers_failed = /** @type {((inputs: Event_Group_Options_Merge_By_Speakers_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Merge_By_Speakers_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_options_merge_by_speakers_failed(inputs)
	if (locale === "de") return de_event_group_options_merge_by_speakers_failed(inputs)
	if (locale === "it") return it_event_group_options_merge_by_speakers_failed(inputs)
	if (locale === "ru") return ru_event_group_options_merge_by_speakers_failed(inputs)
	if (locale === "es") return es_event_group_options_merge_by_speakers_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_options_merge_by_speakers_failed(inputs)
	if (locale === "ja") return ja_event_group_options_merge_by_speakers_failed(inputs)
	if (locale === "hi") return hi_event_group_options_merge_by_speakers_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_options_merge_by_speakers_failed(inputs)
	return en_event_group_options_merge_by_speakers_failed(inputs)
});